<template>
  <ScheduleDialog
    :open="open"
    title="Bloquear horário"
    @close="close"
  >
    <div class="sw-block">
      <label class="sw-block__field">
        Descrição
        <input
          v-model="description"
          type="text"
          class="form-control form-control-solid"
          maxlength="100"
          placeholder="Ex. Almoço"
        >
      </label>
      <div class="sw-block__row">
        <label class="sw-block__field">
          Início
          <input
            v-model="timeBegin"
            type="time"
            class="form-control form-control-solid"
          >
        </label>
        <label class="sw-block__field">
          Término
          <input
            v-model="timeEnd"
            type="time"
            class="form-control form-control-solid"
          >
        </label>
      </div>
      <p v-if="error" class="sw-block__error">{{ error }}</p>
    </div>
    <template #footer>
      <button type="button" class="sw-block__btn" :disabled="loading" @click="close">Fechar</button>
      <button type="button" class="sw-block__btn is-primary" :disabled="loading" @click="submit">
        {{ loading ? 'Salvando…' : 'Bloquear' }}
      </button>
    </template>
  </ScheduleDialog>
</template>

<script>
import http from '../../../helpers/http';
import Alert from '../../../helpers/alert';
import moment from '../../../helpers/date';
import ScheduleDialog from './ScheduleDialog.vue';

export default {
  name: 'ScheduleBlockSlotModal',
  components: { ScheduleDialog },
  props: {
    open: { type: Boolean, default: false },
    datetime: { default: null },
    stepMinutes: { type: Number, default: 15 },
    idProf: { default: null },
  },
  emits: ['close', 'saved'],
  data() {
    return {
      description: '',
      timeBegin: '',
      timeEnd: '',
      error: '',
      loading: false,
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    slotMoment() {
      return this.datetime ? moment(this.datetime) : null;
    },
  },
  watch: {
    open(value) {
      if (!value) return;
      const start = this.slotMoment;
      const step = Number(this.stepMinutes) > 0 ? Number(this.stepMinutes) : 15;
      this.timeBegin = start ? start.format('HH:mm') : '';
      this.timeEnd = start ? start.clone().add(step, 'minutes').format('HH:mm') : '';
      this.description = this.timeBegin ? `Bloqueio de horário ${this.timeBegin}` : '';
      this.error = '';
      this.loading = false;
    },
  },
  methods: {
    close() {
      if (this.loading) return;
      this.$emit('close');
    },
    submit() {
      if (!this.idProf || !this.place?.id_place || !this.slotMoment) {
        this.error = 'Selecione um profissional para bloquear o horário.';
        return;
      }
      if (!this.timeBegin || !this.timeEnd) {
        this.error = 'Informe o início e o término.';
        return;
      }
      if (this.timeEnd <= this.timeBegin) {
        this.error = 'O término precisa ser depois do início.';
        return;
      }
      this.error = '';
      this.loading = true;
      const date = this.slotMoment.format('YYYY-MM-DD');
      http.post(`/places/${this.place.id_place}/professionals/${this.idProf}/availabilities-blocks`, {
        dsc_avail_block: (this.description || `Bloqueio de horário ${this.timeBegin}`).trim(),
        date_begin: date,
        date_end: date,
        time_begin: this.timeBegin,
        time_end: this.timeEnd,
        id_prof: this.idProf,
        id_user: this.userAuth?.id_user,
      }).then(() => {
        this.loading = false;
        Alert.toastSuccess('Bloqueio cadastrado com sucesso.');
        this.$emit('saved');
        this.$emit('close');
      }).catch((error) => {
        this.loading = false;
        this.error = error.response?.data?.message || 'Não foi possível bloquear o horário.';
        Alert.toastError(this.error);
      });
    },
  },
};
</script>

<style scoped>
.sw-block {
  display: grid;
  gap: 0.75rem;
}
.sw-block__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}
.sw-block__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin: 0;
  font-size: 0.75rem;
  font-weight: 700;
  color: #7e8299;
}
.sw-block__field .form-control {
  min-height: 2.35rem;
  font-size: 0.88rem;
}
.sw-block__error {
  margin: 0;
  color: #f1416c;
  font-size: 0.8rem;
  font-weight: 600;
}
.sw-block__btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.4rem;
  margin: 0;
  padding: 0.45rem 0.95rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.5rem;
  background: #fff;
  color: #181c32;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.2;
  box-shadow: none;
  cursor: pointer;
}
.sw-block__btn:hover:not(:disabled) {
  border-color: #780f5a;
  color: #780f5a;
}
.sw-block__btn.is-primary {
  background: #780f5a;
  border-color: #780f5a;
  color: #fff;
}
.sw-block__btn.is-primary:hover:not(:disabled) {
  background: #65104c;
  border-color: #65104c;
  color: #fff;
}
.sw-block__btn:disabled {
  opacity: 0.65;
  cursor: default;
}
</style>
